function ForwardButton() {

    return (
        <button
         type="submit"
         style={{width: "100px", marginTop: "50px", marginLeft: "10px"}}
         className='hero-section-button bg-red font-color-w text-center flex justify-center align-center' 
        >Siguiente
        </button>
  )
}

export default ForwardButton